import React from "react";

const ProductCrudTableSearch = ({ setSKU, listProductsBySku, SKU }) => {

    const handleChange = (e) => {
        //setForm({...form, [e.target.name]: e.target.value});
        setSKU({ [e.target.name]: e.target.value });
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        listProductsBySku();
    }

    return (
        <div>
            <div className="row mb-2">
                <h6>Busqueda de Productos</h6>
            </div>
            <div className="table-responsive rounded-3 d-flex justify-content-center" style={{ border: '1px solid black', paddingTop: '15px' }}>
                <>
                    <form className="row g-3">
                        <div className="col-auto">
                            <label htmlFor="staticEmail2">SKU PADRE</label>
                        </div>
                        <div className="col-auto">
                            <input type="number" className="form-control" id="sku" name="sku" placeholder="ingrese el SKU PADRE" onChange={handleChange} value={SKU?.sku} />
                        </div>
                        <div className="col-auto">
                            <button type="submit" className="btn btn-primary mb-3" onClick={handleSubmit}>Buscar</button>
                        </div>
                    </form>
                </>
            </div>
        </div>
    );
}
export default ProductCrudTableSearch;